import styled from '@emotion/styled';
import COLORS from '$variables/colors';
import { spacing, typography } from '$variables/theme';

export const Wrapper = styled.div`
  background-color: ${COLORS.white};
  border-radius: 4px;
  padding: ${({ fullPadding }) =>
    fullPadding
      ? `${spacing.medium}`
      : `${spacing.medium} ${spacing.medium} 0`};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Tabs = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${spacing.medium};
`;

export const Tab = styled.div`
  padding: ${spacing.xSmall} ${spacing.medium};
  ${({ isActive }) =>
    isActive &&
    `
    color: ${COLORS.blue};
    border-bottom: 2px solid ${COLORS.blue};
    cursor: pointer;
    font-weight: ${typography.fontWeightSemiBold};
  `}
  ${({ isDisabled }) =>
    isDisabled &&
    `
    color: ${COLORS.grey1};
    cursor: default;
  `}

  display: flex;
  align-items: center;
`;

export const TabText = styled.span`
  margin-left: ${spacing.xxSmall};
`;

export const LeftDecorations = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: ${spacing.small};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: ${typography.fontWeightSemiBold};
  margin-bottom: ${spacing.xxSmall};
`;

export const SubTitleContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xxSmall};
`;

export const SubTitle = styled.div`
  font-size: 14px;
  color: ${COLORS.shadow5};
`;
